import React from 'react';

export default function NewItemPicture({
  item, ...props
}) {
  let {smallImage} = item;
  if (!smallImage)
    return null;

  return (
    <div className="text-center">
      <img className="inline-block my-4 mx-auto w-2/3 lg:w-full"
        src={smallImage} alt={item.name || "New Item"}/>
    </div>
  );
}
